/**
 * GA4 (dataLayer) + Meta Pixel (fbq) wishlist events.
 */
(function () {
  'use strict';

  function pushGA4(eventName, productId, productTitle) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    const item_id = String(productId || '');
    const item_name = String(productTitle || '');
    try {
      window.dataLayer.push({
        event: eventName,
        ecommerce: {
          items: [
            {
              item_id,
              item_name,
            },
          ],
        },
      });
    } catch {
      /* ignore */
    }
  }

  function trackAddToWishlist(productId, productTitle) {
    pushGA4('add_to_wishlist', productId, productTitle);
    if (typeof window.fbq === 'function') {
      try {
        window.fbq('trackCustom', 'AddToWishlist', {
          content_ids: [String(productId)],
          content_type: 'product',
        });
      } catch {
        /* ignore */
      }
    }
  }

  function trackRemoveFromWishlist(productId, productTitle) {
    pushGA4('remove_from_wishlist', productId, productTitle);
    if (typeof window.fbq === 'function') {
      try {
        window.fbq('trackCustom', 'RemoveFromWishlist', {
          content_ids: [String(productId)],
          content_type: 'product',
        });
      } catch {
        /* ignore */
      }
    }
  }

  window.WishlistTracking = {
    trackAddToWishlist,
    trackRemoveFromWishlist,
  };
})();
